/* eslint-env node */

import Routes from '../client/routes';
import { hot } from 'react-hot-loader';

export default hot(module)(Routes);
export { Routes };



// WEBPACK FOOTER //
// ./shared/app.js